import type { AssistantV2Answer } from "@/lib/api/assistantV2";
import { ScalarAnswerCard } from "./ScalarAnswerCard";
import { FrameAnswerCard } from "./FrameAnswerCard";

/** Maps the answers[] list, dispatching on each answer's discriminant `type`. */
export function AnswersRenderer({ answers }: { answers: AssistantV2Answer[] }) {
  return (
    <div className="space-y-3">
      {answers.map((answer, i) => {
        switch (answer.type) {
          case "scalar":
            return <ScalarAnswerCard key={i} answer={answer} />;
          case "frame":
            return <FrameAnswerCard key={i} answer={answer} />;
          default:
            // Forward-compat: surface an unknown answer type as raw JSON rather
            // than dropping it.
            return (
              <div
                key={i}
                className="border border-slate-300 bg-slate-50 rounded-lg p-4"
              >
                <div className="text-sm font-semibold text-slate-800">
                  Unsupported answer type:{" "}
                  <span className="font-mono">
                    {(answer as { type?: string }).type ?? "unknown"}
                  </span>
                </div>
                <pre className="mt-2 text-[11px] bg-white border border-slate-200 rounded p-2 overflow-x-auto">
                  {JSON.stringify(answer, null, 2)}
                </pre>
              </div>
            );
        }
      })}
    </div>
  );
}
